import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '@root/app.service';

@Component({
  selector: 'host-demo-page',
  templateUrl: './demo-page.component.html',
  styleUrls: ['./demo-page.component.scss'],
})
export class DemoPageComponent implements OnInit {
  @Input() demoImg;
  @Input() demoCardStyle;
  @Input() demoCardTitle;
  @Input() demoCardDesc;

  get isInternational() {
    return this.app.app.international;
  }

  constructor(private app: AppService) {}

  ngOnInit() {}
}
